import React, { useEffect, useContext } from 'react';
import { useLocation } from "react-router-dom";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js"
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import Warning from "beaktShared/components/Typography/Warning.js";

//services
import { formateDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { transformValueFloattoFormated } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";

export default function ExtratoRoyaltiesDM2({ history, royaltieId })
{
    const session = useContext(SessionContext);
    const podeVerObservacao = session && (session.tipoPerfil === 0 || session.tipoPerfil === 4);

    useEffect(() => {
        let idRoy = null;
        if(location.state)
        {
            idRoy = location.state.royaltieId;
            setshowBackFechamento(true);
        }
        else if(royaltieId)
        {
            idRoy = royaltieId;
            setshowBackFechamento(false);
        }
        
        if(idRoy)
            loadRelatorio(idRoy); 
        else
            showNotification('Não é possivel realizar o carregamento dos dados do relatório, sem o recebimento dos parametros.','danger');
    }, [royaltieId]);

    const [logo] = React.useState(require("assets/img/Logo_DM2.png"));
    const [loading, setLoading] = React.useState(false);
    const [dadosRelatorio, setdadosRelatorio] = React.useState({
        valorFaturamentoTotal: "",
        valorFaturamentoPacotesServicos: "",
        valorFaturamentoProdutos: "",
        valorCartao: "",
        valorRepasseSliptCartaoClinica: "",
        valorCreditosAVista: "",
        valorCreditosFechamento: "",
        valorDebitos: "",
        valorAPagar: "",
        totalReceberAVista: ""
    });

    const loadRelatorio = (royaltieId) =>{        
        const endPoint = "royalties/getExtratoRoyaltie/" + royaltieId;
        setLoading(true);
        UseGetApiSimple(endPoint,0).then(result=>{         
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                setLoading(false);
                return false; 
            }
            setdadosRelatorio(result.data); 
            loadDetalhamento(result.data.detalhamentoRoyaltie);
            loadDetalheProdutoServicoPacote(result.data.detalheProdutoServicoPacoteComRoyaltie);
            setLoading(false);
            return true;                
        });
    };

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });

    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
  
    const location = useLocation();
    const [showBackFechamento, setshowBackFechamento] = React.useState(false);

    const [detalhevendas,setdetalhevendas] = React.useState([]);
    const [detalhecreditos,setdetalhecreditos] = React.useState([]);
    const [detalhepedidos,setdetalhepedidos] = React.useState([]);
    const [detalhedebitos,setdetalhedebitos] = React.useState([]);

    const loadDetalhamento = (result) =>{
        if(result)
        {
            let lstvendas = result.filter(obj => {
            return obj.tipo === 0;
            });
            setdetalhevendas(lstvendas); 
            
            let lstcreditos = result.filter(obj => {
            return obj.tipo === 1;
            });
            setdetalhecreditos(lstcreditos); 
            
            let lstpedidos = result.filter(obj => {
            return obj.tipo === 2;
            });
            setdetalhepedidos(lstpedidos); 

            let lstdebitos = result.filter(obj => {
            return obj.tipo === 3;
            });
            setdetalhedebitos(lstdebitos); 
        } 
    };

    const [listaDetalheItem, setListaDetalheItem] = React.useState([]);
    const loadDetalheProdutoServicoPacote = (result) => {
        if (result)
        {
            setListaDetalheItem(result);
        }
    };

    const back = () =>{
        if(location.state)
        {
          let from = location.state.from;
          if(from === 'clinic')      
            history.push('/adminclinic/fechamentoroyalties');
          else
            history.push('/adminmatriz/fechamentoroyalties');
        }
    };

    return (
        <>
            <div style={{marginTop:'0px !important', paddingTop:'0px !important'}}>
                {
                    loading && 
                    <div className="loadingDash" style={{height:'220px'}}>
                        <CircularProgress size={40} />
                    </div>
                }
                {
                    !loading &&
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <center className="no-print">
                                {
                                    showBackFechamento && 
                                    <Button onClick={ () => back() }>
                                        Voltar
                                    </Button>
                                }
                                <Button color="info" onClick={ () => window.print() }>
                                    Imprimir
                                </Button>
                            </center>
                            <div 
                                className="allowPrint"
                                style={{ 
                                    color:'#3c4858', 
                                    maxWidth:'900px',
                                    margin:'0 auto',
                                    border:'1px solid rgb(206, 206, 206)',
                                    background:'white',
                                    padding:'20px 30px'}}>

                                <div style={{fontSize:'1.2em'}}>
                                    <img src={logo}/>
                                    <div style={{float:'right', textAlign:'right'}}>
                                        <h3> {dadosRelatorio.estabelecimentoDescricao} </h3>
                                        <h4>Referente: {dadosRelatorio.mesAno} </h4>
                                    </div>
                                    <div style={{clear:'both'}}></div>
                                </div>

                                <hr className='lineGrayDashed' />

                                {dadosRelatorio.clinicaEmFaseInauguracao &&
                                    <div style={{ border: '1px solid #ff9800', background: '#fff3e0', padding: '10px 20px', borderRadius: '5px', marginBottom: '15px' }}>
                                        <Warning>
                                            <b>Atenção:</b> A clínica encontra-se em fase de inauguração e os valores foram ajustados proporcionalmente.
                                        </Warning>
                                    </div>
                                }

                                <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                                    <h4 syle={{marginTop:'0px!important'}}><strong>Resumo do Extrato</strong></h4>
                                    <GridContainer style={{background:'#f7f7f7'}}>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <div className='subTituloExtrato'>
                                                <h6>Faturamento</h6>
                                            </div>
                                            <div className='py-10'>
                                                <h6> 
                                                    <b>FATURAMENTO <small>(Total bruto)</small>:</b> 
                                                    <span style={{float: 'right'}}>
                                                        {
                                                            transformValueFloattoFormated(
                                                                dadosRelatorio.totalValorCartaoCredito +
                                                                dadosRelatorio.totalValorCartaoDebito +
                                                                dadosRelatorio.totalValorDinheiro + 
                                                                dadosRelatorio.totalValorOutros)
                                                        }
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>FATURAMENTO <small>(Total líquido)</small>:</b> 
                                                    <span style={{float: 'right'}}>
                                                        {
                                                            transformValueFloattoFormated(
                                                                dadosRelatorio.valorFaturamentoTotal - 
                                                                dadosRelatorio.valorRoyalties)
                                                        }
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>FATURAMENTO <small>(Total Produtos)</small>:</b>
                                                    <span style={{float: 'right'}}>
                                                        {
                                                            transformValueFloattoFormated(
                                                                dadosRelatorio?.valorFaturamentoProdutos +
                                                                dadosRelatorio?.totalProdutoNaoControlaRoyaltie)
                                                        }
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>FATURAMENTO <small>(Total Serviço)</small>:</b>
                                                    <span style={{ float: 'right' }}>
                                                        {
                                                            transformValueFloattoFormated(
                                                                dadosRelatorio?.valorFaturamentoServicos +
                                                                dadosRelatorio?.totalServicoNaoControlaRoyaltie)
                                                        }
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>FATURAMENTO <small>(Total Pacote)</small>:</b>
                                                    <span style={{ float: 'right' }}>
                                                        {
                                                            transformValueFloattoFormated(
                                                                dadosRelatorio?.valorFaturamentoPacotes +
                                                                dadosRelatorio?.totalPacoteNaoControlaRoyaltie)
                                                        }
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                            </div>

                                            <div className='subTituloExtrato'>
                                                <h6>Não Controla Royalties</h6>
                                            </div>
                                            <div className='py-10' style={{marginBottom: '10px'}}>
                                                <h6> 
                                                    <b>TOTAL PRODUTOS:</b>
                                                    <span style={{float: 'right'}}>
                                                        {transformValueFloattoFormated(dadosRelatorio?.totalProdutoNaoControlaRoyaltie)}
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>TOTAL SERVIÇOS:</b>
                                                    <span style={{float: 'right'}}>
                                                        {transformValueFloattoFormated(dadosRelatorio?.totalServicoNaoControlaRoyaltie)}
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>TOTAL PACOTES:</b>
                                                    <span style={{float: 'right'}}>
                                                        {transformValueFloattoFormated(dadosRelatorio?.totalPacoteNaoControlaRoyaltie)}
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                            </div>

                                            <div className='subTituloExtrato'>
                                                <h6>Faturamento Controla Royalties</h6>
                                            </div>
                                            <div className='py-10' style={{marginBottom: '10px'}}>
                                                <h6> 
                                                    <b>TOTAL PRODUTOS:</b>
                                                    <span style={{float: 'right'}}>
                                                        {
                                                            transformValueFloattoFormated(dadosRelatorio?.valorFaturamentoProdutos)
                                                        }
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>TOTAL SERVIÇOS:</b>
                                                    <span style={{float: 'right'}}>
                                                        {
                                                            transformValueFloattoFormated(dadosRelatorio?.valorFaturamentoServicos)
                                                        }
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>TOTAL PACOTES:</b>
                                                    <span style={{float: 'right'}}>
                                                        {
                                                            transformValueFloattoFormated(dadosRelatorio?.valorFaturamentoPacotes)
                                                        }
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                            </div>
                                            
                                            <div className='subTituloExtrato'>
                                                <h6>Royalties (Valor Retido)</h6>
                                            </div>
                                            <div className='py-10'>
                                                <h6> 
                                                    <b>VALOR RETIDO PELA MATRIZ <small>(ROYALTIES)</small>:</b>
                                                    <span style={{float: 'right'}}>
                                                        {transformValueFloattoFormated(dadosRelatorio.valorRoyalties)} 
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                            </div>

                                            <div className='subTituloExtrato'>
                                                <h6>Faturamento Líquido</h6>
                                            </div>
                                            <div className='py-10'>
                                                <h6> 
                                                    <b>FATURAMENTO <small>(Total líquido)</small>:</b> 
                                                    <span style={{float: 'right'}}>
                                                        {
                                                            transformValueFloattoFormated(
                                                                dadosRelatorio.valorFaturamentoTotal - 
                                                                dadosRelatorio.valorRoyalties)
                                                        }
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                            </div>
                                            
                                            <div className='subTituloExtrato'>
                                                <h6>Forma de Pagamento</h6>
                                            </div>
                                            <div className='py-10'>
                                                <h6>
                                                    <b>MÉDIA DE PARCELAS:</b>
                                                    <span style={{float: 'right'}}>
                                                        {dadosRelatorio.mediaParcelas}
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>TOTAL <small>(CARTÃO DE CRÉDITO)</small>:</b>
                                                    <span style={{float: 'right'}}>
                                                        {transformValueFloattoFormated(dadosRelatorio.totalValorCartaoCredito)}
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>TOTAL <small>(CARTÃO DE DÉBITO)</small>:</b>
                                                    <span style={{float: 'right'}}>
                                                        {transformValueFloattoFormated(dadosRelatorio.totalValorCartaoDebito)}
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>TOTAL <small>(DINHEIRO)</small>:</b>
                                                    <span style={{float: 'right'}}>
                                                        {transformValueFloattoFormated(dadosRelatorio.totalValorDinheiro)}
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6> 
                                                    <b>TOTAL <small>(OUTRAS FORMAS DE PAGAMENTO)</small>:</b>
                                                    <span style={{float: 'right'}}>
                                                        {transformValueFloattoFormated(dadosRelatorio.totalValorOutros)}
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                            </div>
                                            
                                            <div className='subTituloExtrato' style={{ display: 'none' }}>
                                                <h6>Financeiro</h6>
                                            </div>
                                            <div className='py-10' style={{ marginBottom: '10px', display: 'none' }}>
                                                <h6> 
                                                    <b>TOTAL DÉBITOS:</b>
                                                    <span style={{float: 'right'}}>
                                                        {transformValueFloattoFormated(dadosRelatorio.valorDebitos)}
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                <h6>
                                                    <b>{ dadosRelatorio.valorAPagar >= 0 ? "TOTAL A RECEBER" : "TOTAL A PAGAR"}:</b>
                                                    <span style={{float: 'right'}}>
                                                        {transformValueFloattoFormated(dadosRelatorio.valorAPagar)}
                                                    </span>
                                                </h6>
                                                <hr className='lineGrayDashed' />
                                                {
                                                    dadosRelatorio.totalReceberAVista > 0 &&
                                                    <>
                                                        <h6>
                                                            <b> RECEBER A VISTA: </b> 
                                                            <span style={{float: 'right'}}>
                                                                {transformValueFloattoFormated(dadosRelatorio.totalReceberAVista)}
                                                            </span>
                                                        </h6>
                                                        <hr className='lineGrayDashed' />
                                                    </>
                                                }
                                            </div>
                                            
                                        </GridItem>
                                    </GridContainer>
                                </div>
                                
                                <hr className='lineGrayDashed' />

                                <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                                    <h4><strong>Detalhamento de Vendas</strong></h4>
                                    {
                                        (detalhevendas && detalhevendas.length > 0)
                                        && 
                                        <>
                                            <table className='table-print min-w-full border border-neutral-200'>
                                                <thead class='border-b border-neutral-200'>
                                                    <tr>
                                                        <th className='border-neutral-200 px-3 py-2' style={{width:'15%'}}>DATA</th>
                                                        <th className='border-neutral-200 px-3 py-2' style={{width:'55%'}}>HISTÓRICO</th>
                                                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>CRÉDITO</th>
                                                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>DÉBITO</th>
                                                        <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>SALDO</th>
                                                    </tr>
                                                </thead>
                                                <tbody>                   
                                                    {
                                                    detalhevendas.map(item => (
                                                        <tr key={item.id} class='border-b border-neutral-200'>
                                                            <td className='border-e border-neutral-200 px-3 py-2 pl-2'>
                                                                {formateDate(item.data)}
                                                            </td>
                                                            <td className='border-e border-neutral-200 px-3 py-2'>
                                                                <p style={{margin:0}}>
                                                                    {item.historico}
                                                                </p>
                                                                <p style={{margin:0}}>
                                                                    <small>
                                                                        <strong>Cliente </strong>{item.nomeCliente}
                                                                    </small>
                                                                </p>
                                                                {
                                                                    item.numAutorizacao != null &&
                                                                    <p style={{margin:0}}>
                                                                        <small>
                                                                            <strong>Autorização </strong>
                                                                            {item.numAutorizacao} ({item.destinatarioPagamento})
                                                                        </small>
                                                                    </p>
                                                                }
                                                            </td>
                                                            <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                                {transformValueFloattoFormated(item.credito)}
                                                            </td>
                                                            <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                                {transformValueFloattoFormated(item.debito)}
                                                            </td>
                                                            <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                                {transformValueFloattoFormated(item.saldo)}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </>
                                    }
                                    {
                                        (!detalhevendas || detalhevendas.length === 0) &&
                                        <div> Não contém registros </div>
                                    } 
                                </div>
                                
                                <hr className='lineGrayDashed' />

                                <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                                    <h4><strong>Detalhamento de Créditos Diversos</strong></h4>
                                    {
                                        (detalhecreditos && detalhecreditos.length > 0)
                                        && 
                                        <table className='table-print min-w-full border border-neutral-200'>
                                            <thead class='border-b border-neutral-200'>
                                                <tr>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'15%'}}>DATA</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'55%'}}>HISTÓRICO</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>CRÉDITO</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>DÉBITO</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>SALDO</th>
                                                </tr>
                                            </thead>
                                            <tbody>                   
                                                {detalhecreditos.map(item => (
                                                    <tr key={item.id} class='border-b border-neutral-200'>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'center'}}>
                                                            {formateDate(item.data)}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2'>
                                                            {item.historico}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                            {transformValueFloattoFormated(item.credito)}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                            {transformValueFloattoFormated(item.debito)}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                            {transformValueFloattoFormated(item.saldo)}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table> 
                                    }
                                    {
                                        (!detalhecreditos || detalhecreditos.length === 0) &&
                                        <div> Não contém registros </div>
                                    }
                                </div>

                                <hr className='lineGrayDashed' />

                                <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                                    <h4><strong>Detalhamento de Compras</strong></h4>
                                    {
                                        (detalhepedidos && detalhepedidos.length > 0)
                                        && 
                                        <table className='table-print min-w-full border border-neutral-200'>
                                            <thead class='border-b border-neutral-200'>
                                            <tr>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'15%'}}>DATA</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'55%'}}>HISTÓRICO</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>CRÉDITO</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>DÉBITO</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>SALDO</th>
                                                </tr>
                                            </thead>
                                            <tbody>                   
                                                {detalhepedidos.map(item => (
                                                    <tr key={item.id} class='border-b border-neutral-200'>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'center'}}>
                                                            {formateDate(item.data)}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2'>
                                                            {item.historico}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                            {transformValueFloattoFormated(item.credito)}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                            {transformValueFloattoFormated(item.debito)}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                            {transformValueFloattoFormated(item.saldo)}
                                                        </td>
                                                    </tr>
                                                ))}                     
                                            </tbody>
                                        </table> 
                                    }
                                    {
                                        (!detalhepedidos || detalhepedidos.length === 0) &&
                                        <div> Não contém registros </div>
                                    }
                                </div>
                                
                                <hr className='lineGrayDashed' />
                                
                                <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                                    <h4><strong>Detalhamento de Débitos Diversos</strong></h4>
                                    {
                                        (detalhedebitos && detalhedebitos.length > 0)
                                        && 
                                        <table className='table-print min-w-full border border-neutral-200'>
                                            <thead class='border-b border-neutral-200'>
                                                <tr>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'15%'}}>DATA</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'55%'}}>HISTÓRICO</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>CRÉDITO</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>DÉBITO</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'10%'}}>SALDO</th>
                                                </tr>
                                            </thead>
                                            <tbody>                   
                                                {detalhedebitos.map(item => (
                                                    <tr key={item.id} class='border-b border-neutral-200'>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'center'}}>
                                                            {formateDate(item.data)}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2'>{item.historico}</td>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                            {transformValueFloattoFormated(item.credito)}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                            {transformValueFloattoFormated(item.debito)}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2' style={{textAlign:'right'}}>
                                                            {transformValueFloattoFormated(item.saldo)}
                                                        </td>
                                                    </tr>
                                                ))}                     
                                            </tbody>
                                        </table> 
                                    }
                                    {
                                        (!detalhedebitos || detalhedebitos.length === 0) &&
                                        <div> Não contém registros </div>
                                    }
                                </div>

                                <hr className='lineGrayDashed' />

                                <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                                    <h4><strong>Detalhamento de Controle de Royalties</strong></h4>
                                    {
                                        (listaDetalheItem || listaDetalheItem.length > 0) &&
                                        <table className='table-print min-w-full border border-neutral-200'>
                                            <thead class='border-b border-neutral-200'>
                                                <tr>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'15%'}}>TIPO</th>
                                                <th className='border-neutral-200 px-3 py-2' style={{width:'55%'}}>DESCRIÇÃO</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {listaDetalheItem.map(item => (
                                                    <tr key={item.id} class='border-b border-neutral-200'>
                                                        <td className='border-e border-neutral-200 px-3 py-2'>
                                                            {item.tipoItem}
                                                        </td>
                                                        <td className='border-e border-neutral-200 px-3 py-2'>
                                                            {item.descricao}
                                                        </td>
                                                    </tr>
                                                ))} 
                                            </tbody>
                                        </table>
                                    }
                                    {
                                        (!listaDetalheItem || listaDetalheItem.length === 0) &&
                                        <div> Não contém registros </div>
                                    }
                                </div>

                                {
                                    podeVerObservacao && dadosRelatorio.observacaoPagamento && dadosRelatorio.observacaoPagamento.trim() !== '' &&
                                    <>
                                        <hr className='lineGrayDashed' />
                                        <div style={{fontSize:'1.2em',marginBottom:'25px'}}>
                                            <h4><strong>Observação</strong></h4>
                                            <p>{dadosRelatorio.observacaoPagamento}</p>
                                        </div>
                                    </>
                                }
                                
                            </div>
                        </GridItem>
                    </GridContainer>
                }
                <br />
                <Snackbar
                    place="tr"
                    color={notification.color}
                    message={notification.message}
                    open={notification.show}
                    closeNotification={() => setNotification(false)}
                    close /> 
            </div>
        </>
    );
}